import React from "react";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { StatementsList } from "@reports/components/StatementsList";
import { messages as rMessages } from "@reports/messages";
import { Page, PageTitle } from "@ui/Page";

const breadcrumbItems = [
    {
        text: <FormattedMessage {...messages.pageStatementsTitle} />,
    },
];

const StatementsPage = () => (
    <Page className="statements-page" breadcrumbs={breadcrumbItems}>
        <PageTitle tag="h1" className="display-2">
            <FormattedMessage {...rMessages.statementPlural} />
        </PageTitle>
        <p className="sub-heading"><FormattedMessage {...rMessages.statementsIntro} /></p>
        <StatementsList />
    </Page>
);

const ConnectedStatementsPage = compose(
    setTitleOnPage(messages.pageStatementsTitle),
)(StatementsPage);

export {
    ConnectedStatementsPage as StatementsPage,
    StatementsPage as StatementsPagePresenter,
};
